import AppState, { POPUPS, SCREENS } from '@/js/AppState';
import Button from '@cmp/shared/Button/Button';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Texts from 'react-sdk/Texts';
import classes from './ScreenHome.module.css';

// import HomeScreens from '@scr/_layouts/HomeScreens/HomeScreens';
// import Config from 'react-sdk/Config';
import PopupsManager from 'react-sdk/PopupsManager';
import SoundPlayer from 'react-sdk/SoundPlayer';
import SaveGame from '@/js/SaveGame';
import CanvasCharacter from '@/components/Dial/CanvasCharacter/CanvasCharacter';
import Logo from '@/components/shared/Logo/Logo';
import Footer from '@/components/shared/Footer/Footer';
import AudioButton from '@/components/Hud/AudioButton/AudioButton';


const ScreenHome = () => {
  const [loading, setLoading] = useState(false);
  const [hasSave, setHasSave] = useState(false);


  // gestion de la connexion et passage à l'écran suivant
  function handleClick() {
    if (hasSave)
      SaveGame.load();
    
    AppState.setScreen(SCREENS.MODULES)

  }

  // check s'il y a une sauvegarde
  useEffect(() => {
    setHasSave(SaveGame.hasSave());

    SoundPlayer.playSound("music_LP")
  }, []);


  function handleClearSave() {
      SaveGame.clearSave()
      setHasSave(false)
  }

  return (
    <div className={classes.ScreenHome}>
      <div className={classes.header}>
        <Logo />
      </div>
      <div className={classes.content} >

        <div className={classes.play_btn}>
          <Button disabled={loading} className={classes.button} onClick={handleClick} name="startButton">
            {hasSave ? Texts.get("home-button-continue") : Texts.get("home-button-play")}
          </Button>

          {!loading && hasSave && AppState.debugMode &&
          <div>
          <a variant='secondary small' onClick={handleClearSave}>
            {Texts.get("home-delete-savegame")}
          </a></div>}
        </div>

        <div className={classes.text} dangerouslySetInnerHTML={{__html: Texts.get("home-content") }}/>
        </div>

      <AudioButton />
      <CanvasCharacter char_id="chef_chantier" attitude="amusement" />
      <Footer />
    </div>

  );
};

export default  observer(ScreenHome)
